import React, {useEffect, useState} from 'react';
import { reduxForm } from 'redux-form';
import { useSelector } from 'react-redux'
import { Tab, Tabs } from 'components/shared/Tabs';
import FMCSAsearch from 'components/Applicants/partial/Modals/FMCSAsearch';
import MotusSearchContent from 'components/Applicants/partial/Modals/MotusSearchContent';
import { Ucc } from './UCC';
import { quickSearchTabs } from 'constants/quickSearch';
import strings from 'strings';
import SosSearch from './SOS/SosSearch';
import SosLinks from 'components/Applicants/partial/Tabs/SecretaryOfState/SosLinks';
import SamgovSearch from './SAMGOV/SamgovSearch';
import NppesSearch from './NPPES/NppesSearch';
import LeieSearch from './LEIE/LeieSearch';
import StateMedicaidSearch from './StateMedicaid/StateMedicaidSearch';
import HealthcareSearch from 'components/HealthcareSearch';
import { getQsTabByIndex, getTabValue } from 'constants/utilityFunctions';
import queryString from 'query-string';
import {useAppContext} from "../../context/AppContext";
import AuthService from "../../tools/AuthService";
import {getCreditCosts} from "../../actions/applicants";
import DemoModeSwitch from 'components/DemoMode/DemoModeSwitch';

const QS_STRING = strings.QUICK_SEARCH
function QuickSearch(props) {
    const {
        handleSubmit,
        getFmcsaData,
        getFmcsaDataByDOT,
        fmcsaData,
        performUccSearch,
        uccSearchResult,
        getFilingDetails,
        uccDetailedReport,
        reset,
        history,
        location,
        retrieveDocument,
        getRetrieveDocuments,
        downLoadAttachmentByFileId,
        getFilingReportsAttachments,
        uploadRoxFiles,
        dispatchProcessing,
        hideFmcsa,
        trialAccount
    } = props

    const {isDemoMode} = useAppContext()
    const { creditUsageEnabled, motusEnabled, samgovEnabled, nppesEnabled, leieEnabled, stateMedicaidEnabled, healthcareSearchEnabled } = AuthService.getClientFeatures()
    const searchAppTabValue = getTabValue(queryString.parse(location.search).tab, hideFmcsa, isDemoMode, samgovEnabled, nppesEnabled, leieEnabled, stateMedicaidEnabled, healthcareSearchEnabled)
    const [openDrawer, setOpenDrawer] = useState({ qs: false, ucc: false, fmcsa: false })
    const sosSearchEnabled = useSelector(state => state.user.userDetails.securityContext.client.sosSearchEnabled)
    const [creditCosts, setCreditCosts] = useState([])

    useEffect(() => {
        if (creditUsageEnabled) {
            getCreditCosts()()
                .then((res) => setCreditCosts(res || []))
                .catch((err) => {
                    console.error('Error fetching credit costs:', err)
                    setCreditCosts([])
                })
        }
    }, [creditUsageEnabled])

    const handleSearchTabChange = (event, newValue) => {
        history.push('?tab=' + getQsTabByIndex(newValue));
    }

    const handleClose = (refreshTable) => {
        setOpenDrawer(prev => ({ ...prev, qs: false }))
        performUccSearch(null, true)
        history.push('?tab=fmcsa');
        reset('QuickSearch')
    }

    const ucc = (
        <Ucc            performUccSearch={performUccSearch}            handleSubmit={handleSubmit}            uccSearchResult={uccSearchResult}            getFilingDetails={getFilingDetails}            uccDetailedReport={uccDetailedReport}            closeDrawer={handleClose}            showDetailedReport={openDrawer.ucc}            closeDetailReport={() => setOpenDrawer(prev => ({ ...prev, ucc: false }))}            retrieveDocument={retrieveDocument}            getRetrieveDocuments={getRetrieveDocuments}            downLoadAttachmentByFileId={downLoadAttachmentByFileId}            getFilingReportsAttachments={getFilingReportsAttachments}            uploadRoxFiles={uploadRoxFiles}            dispatchProcessing={dispatchProcessing}        />
    )

    const fmcsa = (
        <FMCSAsearch            creditCosts={creditCosts}            type='quick search'            getFmcsaData={getFmcsaData}            getFmcsaDataByDOT={getFmcsaDataByDOT}            fmcsaData={fmcsaData}            history={history}            showDetailedReport={openDrawer.fmcsa}            closeDetailReport={() => setOpenDrawer(prev => ({ ...prev, fmcsa: false }))}        />
    )

    const sos = (
        sosSearchEnabled ?
            <SosSearch isQuickSearch creditCosts={creditCosts}/>
            :
            <div className='tabPanel min-height-75'>
                <SosLinks />
            </div>
    )

    const motus = (
        <div className='tabPanel min-height-75'>
            <MotusSearchContent                history={history}                creditCosts={creditCosts}            />
        </div>
    )

    return (
        <>
            <div className='d-flex justify-content-between align-items-center'>
                <h4>{QS_STRING.QUICK_SEARCH}</h4>
                <DemoModeSwitch />
            </div>

            <Tabs                data={quickSearchTabs(hideFmcsa, isDemoMode, trialAccount, motusEnabled, samgovEnabled, nppesEnabled, leieEnabled, stateMedicaidEnabled, healthcareSearchEnabled)}                value={searchAppTabValue}                onChange={handleSearchTabChange}            />
            <Tab value={searchAppTabValue} index={0}>
                <div className='tabPanel min-height-75'>
                    {fmcsa}
                </div>
            </Tab>
            <Tab value={searchAppTabValue} index={1}>
                <div className='tabPanel min-height-75'>
                    {ucc}
                </div>
            </Tab>
            <Tab value={searchAppTabValue} index={2}>
                {sos}
            </Tab>
            <Tab value={searchAppTabValue} index={3}>
                {motus}
            </Tab>
            {samgovEnabled && (
                <Tab value={searchAppTabValue} index={4}>
                    <div className='tabPanel min-height-75'>
                        <SamgovSearch />
                    </div>
                </Tab>
            )}
            {nppesEnabled && (
                <Tab value={searchAppTabValue} index={5}>
                    <div className='tabPanel min-height-75'>
                        <NppesSearch />
                    </div>
                </Tab>
            )}
            {leieEnabled && (
                <Tab value={searchAppTabValue} index={6}>
                    <div className='tabPanel min-height-75'>
                        <LeieSearch />
                    </div>
                </Tab>
            )}
            {stateMedicaidEnabled && (
                <Tab value={searchAppTabValue} index={7}>
                    <div className='tabPanel min-height-75'>
                        <StateMedicaidSearch />
                    </div>
                </Tab>
            )}
            {healthcareSearchEnabled && (
                <Tab value={searchAppTabValue} index={8}>
                    <div className='tabPanel min-height-75'>
                        <HealthcareSearch creditCosts={creditCosts} />
                    </div>
                </Tab>
            )}
        </>
    );
};

export default reduxForm({
    form: 'QuickSearch',
    enableReinitialize: true
})(QuickSearch)